import { call, select, put } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import { loadFailure, loadRequest, loadSuccess } from './actions';

export function* loadProgressSLA({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}slaOcorrencia&token=${state.auth.token}`,
      { protocolo: payload.protocolo }
    );
    yield put(loadSuccess(response.data));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar o progresso da barra de tempo, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
